<template>
  <b-tab
    v-if="gameData"
    title="Game"
  >
    <b-card>
      <div class="mb-4">
        <h4>Game Information</h4>
        <b-row>
          <b-col
            v-if="gameData.tries && gameData.maximumTries"
            md="4"
          >
            <div class="game-stat-card">
              <h6>Tries Used</h6>
              <div class="stat-value">
                {{ gameData.tries }} / {{ gameData.maximumTries }}
              </div>
            </div>
          </b-col>
          <b-col
            v-if="gameData.discount"
            md="4"
          >
            <div class="game-stat-card">
              <h6>Discount Applied</h6>
              <div class="stat-value">
                {{ gameData.discount }}
              </div>
            </div>
          </b-col>
          <b-col
            v-if="gameData.details && gameData.details.length"
            md="4"
          >
            <div class="game-stat-card">
              <h6>Total Attempts</h6>
              <div class="stat-value">
                {{ gameData.details.length }}
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- Game Scores -->
      <div v-if="gameData.details && gameData.details.length">
        <h5>Game Scores</h5>
        <b-table
          striped
          bordered
          hover
          :items="gameDetailsFormatted"
          :fields="gameFields"
          sort-by="time"
          sort-desc
        >
          <template #cell(time)="data">
            {{ formatDate(data.value) }}
          </template>

          <template #cell(score)="data">
            <b-badge
              :variant="getScoreVariant(data.value)"
              class="score-badge"
            >
              {{ formatScore(data.value) }} pts
            </b-badge>
          </template>
        </b-table>
      </div>

      <div v-else>
        <b-alert
          show
          variant="info"
        >
          No game scores recorded for this trip.
        </b-alert>
      </div>
    </b-card>
  </b-tab>
</template>

<script>
import {
  inject, computed,
} from '@vue/composition-api'
import {
  BTab, BTable, BCard, BRow, BCol, BBadge, BAlert,
} from 'bootstrap-vue'
import formatDate from '@/utils/date-format'

export default {
  components: {
    BTab,
    BCard,
    BTable,
    BRow,
    BCol,
    BBadge,
    BAlert,
  },
  setup() {
    const trip = inject('trip')
    const gameData = computed(() => trip.value?.metadata?.game)

    const gameFields = [
      { key: 'time', label: 'Time', sortable: true },
      { key: 'score', label: 'Score', sortable: true },
    ]

    const gameDetailsFormatted = computed(() => {
      if (!gameData.value || !gameData.value.details) return []
      return gameData.value.details.map((detail, index) => ({
        id: index,
        time: detail.time,
        score: detail.score,
      }))
    })

    const formatScore = score => {
      const numScore = parseFloat(score)
      return numScore.toLocaleString()
    }

    const getScoreVariant = score => {
      const numScore = parseFloat(score)
      if (numScore >= 5000) return 'success'
      if (numScore >= 3000) return 'warning'
      if (numScore >= 1000) return 'info'
      return 'secondary'
    }

    return {
      gameData,
      gameFields,
      gameDetailsFormatted,
      formatDate,
      formatScore,
      getScoreVariant,
    }
  },
}
</script>

<style scoped>
.game-stat-card {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  height: 100%;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #495057;
  margin-top: 0.5rem;
}

.score-badge {
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
}
</style>
